<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="ប្រភេទកញ្ចប់ឥវ៉ាន់" name="first"></el-tab-pane>
			<el-tab-pane label="ការកំណត់តម្លៃ" name="second"></el-tab-pane>

		</el-tabs>

		<div v-if="tabName == 'second'">
			<md-table>
				<md-table-row>
					<!-- <md-table-head>n.o</md-table-head> -->
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>តម្លៃ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(setting, index) in settingList">
					<!-- <md-table-cell>{{index + 1}}</md-table-cell> -->
					<md-table-cell>{{setting.name}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="settingList[index].value"
								:value="settingList[index].value" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">Update</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == 'first'">
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>តម្លៃ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(package_type, index) in packageTypeList" v-if="package_type.id != 1">
					<md-table-cell>{{index}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="packageTypeList[index].name"
								:value="packageTypeList[index].name" @keyup.enter="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="updatePackageType(index, package_type.id)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="deletePackageType(package_type.id)">
							<md-icon>delete</md-icon>
							<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell>បន្ថែមថ្មី</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="packageType.name"
								:value="packageType.name" @keyup.enter="createPackageType()">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="createPackageType()">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">បន្ថែមថ្មី</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this ticket ?"
			md-content="By clicking OK this ticket will be deleted from the database and this action can not be undone."
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>

	export default {

		created() {
			this.getSettings();
		},
		data() {
			return {
				isValid: true,
				tabName: 'first',
				packageTypeList: [],
				packageType: {
					name: ""
				},
				settingList: [
					{
						id: "001",
						name: "ប្តូរប្រាក់ 1USD",
						value: 4100
					}
				]
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.packageTypeList = data.body.data.package_type
				})
			},
			updatePackageType(index, package_type_id) {
				this.$http.post(this.config.api + "/admin/setting/package_type/update", {
					package_type_id: package_type_id,
					value: this.packageTypeList[index].name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រភេទកញ្ចប់ត្រូវបានកែប្រែដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			deletePackageType(package_type_id) {
				this.$http.post(this.config.api + "/admin/setting/package_type/delete", {
					package_type_id: package_type_id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រភេទកញ្ចប់ត្រូវបានលុបចេញដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			createPackageType() {
				this.$http.post(this.config.api + "/admin/setting/package_type/post", {
					name: this.packageType.name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រភេទកញ្ចប់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.packageType.name = "";
						this.getSettings();
					}
				})
			}

		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Settings/View.vue